module.exports = __webpack_public_path__ + "fonts/NunitoSans_10pt-Light.b8426fa7.ttf";